// src/components/layout/Header.jsx

import React from "react";
import "../../assets/styles/global.css";
import MobileMenu from "../layout/MobileMenu";

function Header() {
  return (
    <header className="main-header">
      <div className="logo">Flexotec Maria</div>
     
      <nav>
        <a href="#services">الخدمات</a>
        <a href="#contact">اتصل بنا</a>
        <a href="/about" className="about-link">من نحن</a>

      </nav>
      <MobileMenu />

    </header>
  );
}

export default Header;
